<template>
  <page-layout>
    <div class="w-full flex justify-between md:p-20 pb-20 flex-wrap">
      <section class=" w-full lg:w-1/2  flex justify-center flex-col">
        <h2 class="text-white text-shadow-pop-left text-5xl w-full text-center">
          {{$t('projects')}}</h2>
        <p class="text-lg text-white text-center mt-2  px-4 md:px-0">{{$t('projects-subtitle')}}</p>
        <p class="text-lg text-white text-site-300 my-2 w-full text-center">
          {{$t('projects-subtitle-2')}} </p>
      </section>
     <portfolio-card v-for="work in works" :key="work.name" :portfolio="work"></portfolio-card>
    </div>
  </page-layout>
</template>
<script>
import PageLayout from '@/layouts/PageLayout.vue';
import PortfolioCard from '@/components/PortfolioCard.vue';
import { works } from '@/data/works';

export default {
  name: 'Portfolio',
  components: {
    PageLayout,
    PortfolioCard,
  },
  data() {
    return {
      works,
    };
  },
  created() {
    this.$store.dispatch('UPDATE_TITLE_STATE', { value: 'portfolio' });
  },
};
</script>
<style scoped>
  .wrapper-lottie {
    border-radius: 67% 33% 20% 80% / 46% 21% 79% 54% ;
  }
</style>
